import { z } from "zod";

export const smbLpKeysSchema = z.array(z.string().trim().min(1).max(160)).max(3)
  .refine(keys => new Set(keys).size === keys.length, "LP selections must be unique");
export const smbLpDesignSystemIdSchema = z.string().trim().min(1).max(255).nullable();
export const smbLpWarningSchema = z.enum([
  "unresolved", "inactive", "wrong_source", "brand_restricted",
  "missing_registration", "missing_html", "studio_source_unverified",
  "not_smb_brand",
]);
export const smbLpItemSchema = z.object({
  key: z.string(), label: z.string(), description: z.string().nullable(),
  thumbnail: z.string().nullable(), smbOnly: z.boolean(), eligible: z.boolean(), warnings: z.array(smbLpWarningSchema),
  previewHtml: z.string().nullable().optional(),
});
export const smbLpCatalogQuerySchema = z.object({
  scope: z.literal("manual-smb-home").optional(),
  brandId: z.string().uuid().optional(),
  designSystemId: smbLpDesignSystemIdSchema.optional(),
  selectedKeys: z.string().max(500).transform(value => value ? value.split(",") : [])
    .pipe(smbLpKeysSchema).optional(),
  page: z.coerce.number().int().min(1).max(10000).default(1),
  pageSize: z.coerce.number().int().min(1).max(100).default(50),
}).strict();
export const smbLpCatalogResponseSchema = z.object({
  items: z.array(smbLpItemSchema), total: z.number(), page: z.number(), pageSize: z.number(),
});
export const smbDesignSystemsResponseSchema = z.object({
  designSystems: z.array(z.object({
    id: z.string().trim().min(1), name: z.string().trim().min(1),
    isReserved: z.boolean(), isActive: z.boolean(),
  })),
  available: z.boolean(), error: z.string().nullable(),
});
export type SmbLpItem = z.infer<typeof smbLpItemSchema>;
